<template>

  <DAppGroup :list="dapps">
    <template slot="title">
      <slot name="title"></slot>
    </template>
    <template slot="item" slot-scope="item">
      <DAppCard :dapp="item.data"></DAppCard>
    </template>
  </DAppGroup>

</template>

<script>
  import DAppCard from './DAppCard'
  import DAppGroup from './DAppGroup'

  export default {
    name: 'DAppCardGroup',
    components: {DAppGroup, DAppCard},
    props: ['dapps'],
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/widgets/DAppCardGroup.vue